export interface Item {
  id: number;
  description: string;
}

export class ItemRoles {
  id: number;
  description: string;
  selected: boolean = false;
}

export interface ItemCondition {
  id: number;
  condition: string;
}

export interface ColorItem extends Item {
  color: string
}

export interface ConsultantItem extends Item {
  userId: number;
}

export interface AssignedTeamItem extends Item {
  type: string;
  canBeViewer: boolean;
  canBeReviewer: boolean;
  canBeResponder: boolean;
  ppCanBeViewerFile: boolean;
  ppCanBeReviewerFile: boolean;
  pPcanBeApprover: boolean;
}

export interface AssignedTeamControlItem extends Item {
  id: number;
  description: string;
  type: string;
  canView: boolean;
  canEdit: boolean;
  canParameterize: boolean;
  canRun: boolean;
  canSeeResult: boolean;
}

export interface AssignedTeamBoardItem extends Item {
  id: number;
  description: string;
  type: string;
}

export interface ItemFormat {
  id: number;
  format: string;
}

export interface ItemOperator {
  id: number;
  operator: string;
}

export interface ItemColumn {
  id: number;
  columnType: string;
}